import React, { useState } from 'react';

import CorruptAssignmentRow from './CorruptAssignmentRow';

const CorruptAssignmentsTable = ({ empID, assignments, showErrorMessage, isEditable }) => {
    const [isLocked, setIsLocked] = useState(false);

    return (
        <table className='table corrupt-assignments-table'>
            <thead>
                <tr>
                    <th scope='col'>Start</th>
                    <th scope='col'>Slut</th>
                    <th scope='col'>Typ</th>
                    <th scope='col'>Procent</th>
                    <th scope='col'>Beskrivning</th>
                    {isEditable && <th scope='col'></th>}
                </tr>
            </thead>
            <tbody>
                {assignments.map((assignment) => (
                    <CorruptAssignmentRow
                        key={assignment.begWek + assignment.dsc}
                        empID={empID}
                        assignment={assignment}
                        isLocked={isLocked}
                        setIsLocked={setIsLocked}
                        showErrorMessage={showErrorMessage}
                    />
                ))}
            </tbody>
        </table>
    );
};

export default CorruptAssignmentsTable;
